/* ici21 — editorial homepage behaviours (vanilla, no deps) */
(function () {
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    /* ---- Scroll reveals ---- */
    var reveals = [].slice.call(document.querySelectorAll(".ici21-reveal"));
    if (reduce || !("IntersectionObserver" in window)) {
      reveals.forEach(function (el) { el.classList.add("is-visible"); });
    } else {
      // stagger: delay cards within a [data-ici21-stagger] group
      document.querySelectorAll("[data-ici21-stagger]").forEach(function (group) {
        [].slice.call(group.querySelectorAll(".ici21-reveal")).forEach(function (card, i) {
          card.style.transitionDelay = (i * 0.04) + "s";
        });
      });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add("is-visible"); io.unobserve(en.target); }
        });
      }, { rootMargin: "0px 0px -10% 0px", threshold: 0.1 });
      reveals.forEach(function (el) { io.observe(el); });
    }

    /* ---- Reviews auto-rotator ---- */
    document.querySelectorAll("[data-ici21-reviews]").forEach(function (root) {
      var slides = [].slice.call(root.querySelectorAll(".ici21-review"));
      var dots = [].slice.call(root.querySelectorAll(".ici21-review-dot"));
      if (slides.length < 2) return;
      var idx = 0, timer = null;
      function show(n) {
        slides[idx].classList.remove("is-active");
        if (dots[idx]) dots[idx].classList.remove("is-active");
        idx = (n + slides.length) % slides.length;
        slides[idx].classList.add("is-active");
        if (dots[idx]) dots[idx].classList.add("is-active");
      }
      function start() { if (reduce) return; stop(); timer = setInterval(function () { show(idx + 1); }, 5000); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      dots.forEach(function (d, i) { d.addEventListener("click", function () { show(i); start(); }); });
      root.addEventListener("mouseenter", stop);
      root.addEventListener("mouseleave", start);
      start();
    });

    /* ---- Story image parallax ---- */
    if (!reduce) {
      var pxEls = [].slice.call(document.querySelectorAll("[data-ici21-parallax]"));
      if (pxEls.length) {
        var ticking = false;
        function update() {
          pxEls.forEach(function (el) {
            var r = el.parentElement.getBoundingClientRect();
            var progress = (r.top + r.height / 2 - window.innerHeight / 2);
            el.style.transform = "translateY(" + (progress * -0.04).toFixed(1) + "px)";
          });
          ticking = false;
        }
        window.addEventListener("scroll", function () {
          if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
        }, { passive: true });
        update();
      }
    }
  });
})();
